import ApiService from '../../api/api';
import Vuex from 'vuex';
import Vue from 'vue';
import {router} from '../../router';

Vue.use(Vuex);

export default {
    namespaced: true,
    state() {
        return{
            step: 1,
            type: 'login',
            modal: null,
            form: {
                name: '',
                epitaph: '',
                start: {
                    day: '',
                    month: '',
                    year: ''
                },
                end: {
                    day: '',
                    month: '',
                    year: ''
                },
                page_type_id: 2,
                main_image: null,
                published_page: true,
                accessible_by_password: false,
                master_id: '',
                user_id: '',
                partner_id: '',
                author_epitaph: '',
                burial_id: '',
                burial: '',
                copyright: false,
                cropper_main_image: true,
                subscription_id: null
            },
        }
    },
    getters: {
    },
    mutations: {
        setStep(state, value) {
            state.step = value;
        },
        setType(state, type) {
            state.type = type;
        },
        setPageType(state, type) {
            state.form.page_type_id = type;
        },
        setSubscriptionId(state, id) {
            state.form.subscription_id = id;
        },
        setIds(state, ids) {
            state.form.master_id = ids.master_id;
            state.form.user_id = ids.user_id;
            state.form.partner_id = ids.partner_id;
        },
        setBurialId(state, burial) {
            state.form.burial = burial.flag;
            state.form.burial_id = burial.id;
        },
        setModal(state, value) {
            state.modal = value;
        }
    },
    actions: {
        createPage({state, commit, getters}, slug){
            Vue.prototype.$loading(Vue.prototype.$optionsLoading);

            if (slug) {
                state.form.slug = slug;
            }

            return new Promise((resolve, reject) => {
                ApiService.post('/page', state.form)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    })
                    .finally(() => {
                        Vue.prototype.$loading({}).close();
                    });
            });
        },
        expandPage({state, commit, getters}, slug) {
            if (router.currentRoute.name === 'admin-pages') {
                return new Promise((resolve, reject) => {
                    ApiService.post('/page/expand-page', {page_slug: slug})
                        .then((response) => {
                            resolve(response);
                        }).catch((error) => {
                        reject(error);
                    });
                });
            } else {
                Vue.prototype.$loading(Vue.prototype.$optionsLoading);

                ApiService.post('/page/expand-page', {page_slug: slug})
                    .then((response) => {
                        //здесь будет вызов окна оплаты
                        if (window.laravel.isAdmin)
                            router.push({name: 'admin-edit-page', params: {slug: slug}});
                        else if (window.laravel.isMaster)
                            router.push({name: 'master-edit-page', params: {slug: slug}});
                        else if (window.laravel.isPartner)
                            router.push({name: 'partner-edit-page', params: {slug: slug}});
                        else
                            router.push({name: 'user-edit-page', params: {slug: slug}});

                        window.location.reload(false);
                    })
                    .catch((error) => {
                        console.log(error);
                    })
                    .finally(() => {
                        Vue.prototype.$loading({}).close();
                    });
            }
        },
        checkDuplicatePage({state}, form) {
            Vue.prototype.$loading(Vue.prototype.$optionsLoading);

            return new Promise((resolve, reject) => {
                ApiService.post('/check-duplicate-page', form)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    })
                    .finally(() => {
                        Vue.prototype.$loading({}).close();
                    });
            });
        },
        checkShortPageLimit() {
            return new Promise((resolve, reject) => {
                ApiService.post('/page/check-limit')
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        }
    }
};


